import React from 'react';
import { IconProps } from './types';

export const SwapIcon: React.FC<IconProps> = (props) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <polyline points="16 3 21 3 21 8" />
    <line x1="4" y1="14" x2="21" y2="3" />
    <polyline points="8 21 3 21 3 16" />
    <line x1="20" y1="10" x2="3" y2="21" />
  </svg>
);
